import React from 'react'
import PropTypes from 'prop-types'

import { MintButtonsLayout } from '../styles/PageLayout'

import BtnMintOne from './icons/btnMintOne'
import BtnMintTwo from './icons/btnMintTwo'
import BtnMintThree from './icons/btnMintThree'
import BtnMintFour from './icons/btnMintFour'
import BtnMintFive from './icons/btnMintFive'

/**
 * A list of Mint Buttons to be used in Project Details pages.
 * @param {ComponentProps} props
 * @param {boolean} props.isColumn
 * @returns {StatelessComponent}
 */
const MintButtons = ({ isColumn, selected, setSelected }) => (
  <MintButtonsLayout column={isColumn}>
    <BtnMintOne className={selected === 1 && 'selected'} onClick={() => setSelected(1)} />
    <BtnMintTwo className={selected === 2 && 'selected'} onClick={() => setSelected(2)} />
    <BtnMintThree className={selected === 3 && 'selected'} onClick={() => setSelected(3)} />
    <BtnMintFour className={selected === 4 && 'selected'} onClick={() => setSelected(4)} />
    <BtnMintFive className={selected === 5 && 'selected'} onClick={() => setSelected(5)} />
  </MintButtonsLayout>
)

MintButtons.propTypes = {
  isColumn: PropTypes.bool,
}

MintButtons.defaultProps = {
  isColumn: undefined,
}

export default MintButtons
